var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C4C4C4;}\r\n\t.st1{fill:#616160;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#C4C4C4;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st5{fill:#616160;stroke:#616160;stroke-width:0.25;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:#616160;stroke-miterlimit:10;stroke-dasharray:2.0068,2.0068;}\r\n\t.st7{fill:#616160;stroke:#616160;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st10{fill:#C4C4C4;stroke:#FFFFFF;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;stroke-dasharray:1.9724,1.9724;}\r\n\t.st12{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.5,17.5h-13c-0.552,0-1-0.448-1-1v-13c0-0.552,0.448-1,1-1h13c0.552,0,1,0.448,1,1v13 C17.5,17.052,17.052,17.5,16.5,17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.5,18h-13C2.673,18,2,17.327,2,16.5v-13C2,2.673,2.673,2,3.5,2h13C17.327,2,18,2.673,18,3.5v13 C18,17.327,17.327,18,16.5,18z M3.5,3C3.225,3,3,3.224,3,3.5v13C3,16.775,3.225,17,3.5,17h13c0.275,0,0.5-0.225,0.5-0.5v-13 C17,3.224,16.775,3,16.5,3H3.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.529,17.029H4.471c-0.827,0-1.5-0.673-1.5-1.5V4.47c0-0.827,0.673-1.5,1.5-1.5h11.059 c0.827,0,1.5,0.673,1.5,1.5v11.059C17.029,16.356,16.356,17.029,15.529,17.029z M4.471,3.97c-0.275,0-0.5,0.224-0.5,0.5v11.059 c0,0.275,0.225,0.5,0.5,0.5h11.059c0.275,0,0.5-0.225,0.5-0.5V4.47c0-0.276-0.225-0.5-0.5-0.5H4.471z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.028,13.205h-1.34V6.78h3.683v1.116H7.028v1.656h2.18v1.112h-2.18V13.205z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M14.815,11.873h-0.773v1.332h-1.326v-1.332H9.974v-0.944L12.79,6.78h1.252v4.038h0.773V11.873z M12.716,10.818 v-1.09c0-0.181,0.007-0.444,0.021-0.791c0.015-0.345,0.026-0.546,0.035-0.602h-0.035c-0.108,0.24-0.239,0.475-0.391,0.703 l-1.178,1.779H12.716z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF4);
export default __webpack_public_path__ + "static/media/_F4.a7613001d6f36a145c1d1cf1a4fdc95b.svg";
export { ForwardRef as ReactComponent };